class SurveyValue {
  constructor(key) {
    this.key = key
  }

  toKey() {
    return `${this.key}`
  }

  toLabel() {
    return this.toKey()
  }

  toReadable() {
    return this.toLabel()
  }

  toSummaryLabel() {
    return this.toLabel()
  }

  toValidatable() {
    return this.toKey()
  }

  static keyToObject() {
    throw new Error('keyToObject method has not been implemented.')
  }
}

export default SurveyValue
